/* eslint-disable */
import React, { Component } from 'react'
import { View, Text, TouchableOpacity } from 'react-native'
//import Video from 'react-native-video'
import styles from './Styles/CaptionComponentStyle'
import TextComponent from './TextComponent'
import { SvgCloseRed } from './SvgComponent'
import { getAvatar, getCharityUri } from '../Lib/utils'
import { Fonts } from '../Themes'
//import FastImage from 'react-native-fast-image'

export default class CaptionComponent extends Component {
  render() {
    const { data, text, rawPrice = null, price, tokenPrice = null, isAvatar = false, isProduct = false,
      onPressClose, isDonate = false, isIsell = false, isClose = true } = this.props
    console.tron.display({name: 'CaptionComponent', preview: `render`, value: {data}})
    const donateUrl = data.ImageUrl != null ? data.ImageUrl : (data.FundMe ? getAvatar(data.CharityId) : getCharityUri(data.CharityId))
    const numDescLines = isDonate ? 2 : 1
    const priceStr = rawPrice == null || rawPrice != 0 ? `${price} ` : '' // cannot buy with dollars, but can with tokens

    let mediaView = null
    if (isAvatar)
      mediaView = <Image style={styles.image} source={{ uri: getAvatar(data.UserId) }} />
    if (isDonate)
      mediaView = <Image style={styles.image} resizeMode="contain" source={{ uri: donateUrl }} />

    console.log("CaptionComponent data = " + JSON.stringify(data))
    if (isProduct)
      if (data.Video)
        mediaView = <Image style={styles.image} resizeMode="cover" source={{ uri: data.Video }} repeat={true} muted={true} />
      else
        mediaView = <Image style={styles.image} source={{ uri: data.Image }} />
    // {!!price && !isDonate && <TextComponent text={price} style={[styles.price, isDonate && styles.whiteText]} />}
    const localTokenPrice = Number(tokenPrice).toLocaleString()
    const tokenStr = `${localTokenPrice} Tokens`
    return (
      <View style={[styles.container,styles.shadow]}>
        <View style={styles.container}>
          <View style={[styles.content, { backgroundColor: isDonate ? Fonts.style.color.tagDonationColor : `#FFFFFF` }]}>
            {mediaView}
            <View style={[styles.middle, isAvatar && styles.center]}>
              <TextComponent adjustsFontSizeToFit={false} numberOfLines={numDescLines} text={text} style={[styles.text, isDonate && styles.whiteText]} />
              {!!price && !isDonate && <Text numberOfLines={1} style={[styles.price, isDonate && styles.whiteText]}>
                {priceStr}
                {tokenPrice && <Text style={[styles.price, styles.tokenText]}>{tokenStr}</Text>}
              </Text>}
            </View>
            {isClose &&
              <TouchableOpacity style={[styles.close]} onPress={() => onPressClose()}>
                <SvgCloseRed size={10} />
              </TouchableOpacity>
            }
          </View>
          <View style={[styles.triangle, this.props.triangle, { borderBottomColor: isDonate ? Fonts.style.color.tagDonationColor : `#FFFFFF` }]} />
        </View>
      </View >
    )
  }
}
